import { CapoPlugin } from '@unhead/vue';
export default process.server ? [CapoPlugin({ track: true })] : [];